



































































































































































































































































































import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Meta } from '@/tools/page'
import MeLayout from '@/components/globals/MeLayout.vue'
import Icon from '@/components/globals/Icon.vue'
import Dots from '@/components/me/Dots.vue'
import PublicProfileModal from '@/components/modal/PublicProfileModal/PublicProfileModal.vue'
import { PartialAuthUser } from '@/store/modules/auth/getters'
import { GradeProgress, getAuthUser } from '@/core/Auth'
import { getMe, MeResponse, GradeForecastType } from '@/core/Me'
import { passCircleImages, Grade } from '@/core/Grades'
import { logout } from '@/externals/gyym/auth'
import { StoreAuthLogout } from '@/store/modules/auth/types'
import store from '@/store'
import router from '@/router'
import { updateMe } from '@/core/Me'
import { StoreAuthUser } from '@/store/modules/auth/types'
import snackbar from '@/tools/snackbar'
import dayjs from 'dayjs'
import { PointSubscription } from '@/core/PointSubscriptions'

const PAGE_TITLE = 'マイページ'
const PAGE_META: Meta[] = []

export default Vue.extend({
  components: {
    MeLayout,
    Icon,
    Dots,
    PublicProfileModal,
  },
  data() {
    return {
      isLoading: false,
      me: {
        isKarteRegistered: true,
      } as any as MeResponse,
    }
  },
  computed: {
    passCircleImages() {
      return passCircleImages
    },
    user(): PartialAuthUser {
      return this.$store.getters['auth/user']
    },
    isCorporateUser(): boolean {
      return this.me.isCorporateMember
    },
    isSubscribedUser(): boolean {
      return this.$store.getters['auth/isSubscribed']
    },
    subscription(): PointSubscription | null {
      return this.$store.getters['auth/subscription']
    },
    plan(): PointSubscription['plan'] | null {
      return this.subscription?.plan ?? null
    },
    subscriptionFailure(): PointSubscription['lastPaymentFailure'] | null {
      return this.subscription?.lastPaymentFailure ?? null
    },
    latestRank(): number | null {
      return this.me.latestRank
    },
    corporateName(): string {
      return this.me.corporation?.name || ''
    },
    avatarImagePath(): string {
      return this.me.imagePath ? this.$getImageUrl(this.me.imagePath) : ''
    },
    points(): number {
      return this.$store.getters['auth/point']
    },
    expiringPoints(): number {
      return (this.me.pointsToExpire ?? []).reduce(
        (acc, p) => acc + p.balance,
        0
      )
    },
    progress(): GradeProgress | null {
      return this.$store.getters['auth/progress']
    },
    currentGrade(): Grade | null {
      return this.progress?.currentGrade ?? null
    },
    upperGrade(): Grade | null {
      return this.progress?.upperGrade ?? null
    },
    lowerGrade(): Grade | null {
      return this.progress?.lowerGrade ?? null
    },
    isGradeForcastUp(): boolean {
      return this.progress?.forecast === GradeForecastType.UP
    },
    isGradeForcastKeep(): boolean {
      return this.progress?.forecast === GradeForecastType.KEEP
    },
    isGradeForcastDown(): boolean {
      return this.progress?.forecast === GradeForecastType.DOWN
    },
    usageNumUntilNextGrade(): number {
      return (
        (this.upperGrade?.monthlyReservationNumToAchieve ?? 0) -
        (this.progress?.fluctuateFactor.monthlyReservationNum ?? 0)
      )
    },
    usageNumToKeepGrade(): number {
      return (
        (this.currentGrade?.monthlyReservationNumToKeep ?? 0) -
        (this.progress?.fluctuateFactor.monthlyReservationNum ?? 0)
      )
    },
    achievementRate(): number {
      const rate = this.progress?.achievementRate ?? 0
      return rate > 100 ? 100 : rate
    },
    currentPassType(): string | null {
      return this.currentGrade
        ? this.currentGrade.key.replace('user_grade_', '')
        : null
    },
    nextPaymentDate(): string {
      return this.user.pointSubscription?.nextPaymentAt
        ? dayjs(this.user.pointSubscription.nextPaymentAt).format('M月D日')
        : ''
    },
  },
  beforeRouteEnter(_, from, next) {
    if (!store.getters['auth/user'].name) {
      if (from.matched.length === 0) {
        // プロフィール未登録の場合、この画面にはアクセスできないので直アクセスの場合施設一覧ページを挟ませる
        next('/facilities')
      }
      router.app.$modal.push('ProfileModal')
      next(false)
    } else {
      next()
    }
  },
  async created() {
    this.$setPageTitle(PAGE_TITLE)
    this.$setPageMeta(PAGE_META)
    this.fetchMe()
  },
  methods: {
    async fetchMe() {
      this.isLoading = true
      this.me = await getMe()
      this.isLoading = false
    },
    async logout(): Promise<void> {
      await logout()
      this.$router
        .push(`/`)
        // 遷移を開始してからログイン状態を削除する
        .then(() => {
          this.$store.commit(new StoreAuthLogout())
        })
        .catch((_) => {})
    },
    async onPublicProfileSubmit({
      nickname,
      imageFile,
      enthusiasmComment,
    }: {
      nickname: string
      imageFile: File | null
      enthusiasmComment: string
    }) {
      try {
        await updateMe({
          nickname,
          enthusiasmComment,
          ...(imageFile ? { image: imageFile } : {}),
        })
        snackbar({ text: '公開プロフィールを更新しました' })
      } catch (e) {
        Sentry.captureException(e)
        snackbar({ text: '公開プロフィールを更新できませんでした' })
      }

      try {
        const authUser = await getAuthUser()
        this.$store.commit(new StoreAuthUser(authUser))
        this.fetchMe()
      } catch (e) {
        Sentry.captureException(e)
        snackbar({ text: '最新のプロフィールの取得に失敗しました' })
      }
    },
  },
})
